export function getView(app, tab) {
  let statuses = new Set(app.connections.map(item => item.status))

  // if they've a selected app_id, and no connections, it meaans they were forwarded from a connection setup,
  // and have a connection, but the apps query has not refreshed

  if (statuses.has('active') || tab.selected?.app_id === app.id) {
    return 'Connected'
  } else if (
    ['error', 'error_refresh', 'expired'].some(item => statuses.has(item))
  ) {
    return 'Error'
  } else if (statuses.has('inactive')) {
    return 'Disconnected'
  } else {
    return 'No'
  }
}
